// extracted by mini-css-extract-plugin
export default {"quantityLabel":"styles_quantityLabel__C41pq","iconTooltip":"styles_iconTooltip__rijcr","required":"styles_required__JTKAy"};